// extracted by mini-css-extract-plugin
module.exports = {"main":"otherArcehtypes_main__v0CVM","wrapper":"otherArcehtypes_wrapper__bcCJA"};